// Box Summary updater for Shopify cart
(function() {
  // Function to calculate box summary
  function calculateBoxSummary(quantity, limit, productTitle) {
    const fullBoxes = Math.floor(quantity / limit);
    const remainder = quantity % limit;
    return `${quantity} ${productTitle} = ${fullBoxes > 0 ? fullBoxes + ' box' + (fullBoxes !== 1 ? 'es' : '') : ''}${remainder > 0 ? ' + ' + remainder + ' extra' : ''}`;
  }
  
  // Find the product limit from the current summary
  function extractProductLimit(summaryText) {
    // Extract quantity and product title
    const match = summaryText.match(/(\d+)\s+(.+?)\s+=\s+/);
    if (!match) return null;
    
    const oldQuantity = parseInt(match[1]);
    const productTitle = match[2];
    
    // Calculate limit from existing values
    const boxMatch = summaryText.match(/(\d+)\s+box/);
    const extraMatch = summaryText.match(/\+\s+(\d+)\s+extra/);
    
    if (!boxMatch) return null;
    
    const boxes = parseInt(boxMatch[1]);
    const extras = extraMatch ? parseInt(extraMatch[1]) : 0;
    
    // Calculate product limit
    if (boxes > 0) {
      const productLimit = Math.round((oldQuantity - extras) / boxes);
      return {
        limit: productLimit,
        title: productTitle
      };
    }
    
    return null;
  }
  
  // Update server-side cart
  function updateCartItemProperty(itemKey, quantity, newSummary) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity,
        properties: { 'Box Summary': newSummary }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(`Updated box summary on server: ${newSummary}`);
      return data;
    })
    .catch(error => {
      console.error('Error updating box summary:', error);
      throw error;
    });
  }
  
  // Update all visible box summaries
  function updateAllVisibleSummaries() {
    const cartItems = document.querySelectorAll('tr.cart-item, .cart-item');
    
    cartItems.forEach(item => {
      // Find the quantity input
      const quantityInput = item.querySelector('.quantity__input');
      if (!quantityInput) return;
      
      const quantity = parseInt(quantityInput.value);
      if (isNaN(quantity)) return;
      
      // Find the box summary element
      const boxSummaryElement = Array.from(item.querySelectorAll('.product-option')).find(option => {
        const dt = option.querySelector('dt');
        return dt && dt.textContent.includes('Box Summary');
      });
      
      if (!boxSummaryElement) return;
      
      const summaryValueElement = boxSummaryElement.querySelector('dd');
      if (!summaryValueElement) return;
      
      const currentSummary = summaryValueElement.textContent;
      const productInfo = extractProductLimit(currentSummary);
      
      if (!productInfo) return;
      
      // Check if the summary matches the quantity
      const match = currentSummary.match(/^(\d+)/);
      if (match && parseInt(match[1]) !== quantity) {
        const newSummary = calculateBoxSummary(quantity, productInfo.limit, productInfo.title);
        
        // Update the visible text
        summaryValueElement.textContent = newSummary;
        console.log(`Updated visible box summary to: ${newSummary}`);
        
        // Get the item key
        const itemKey = item.dataset.key || 
                       item.dataset.itemKey || 
                       item.querySelector('[data-key]')?.dataset.key ||
                       item.id?.replace('CartItem-', '') ||
                       quantityInput.dataset.index;
        
        if (itemKey) {
          // Update server
          updateCartItemProperty(itemKey, quantity, newSummary);
        }
      }
    });
  }
  
  // Watch for quantity changes
  function setupQuantityListeners() {
    const quantityInputs = document.querySelectorAll('.cart-item .quantity__input, .cart-item__quantity .quantity__input');
    
    quantityInputs.forEach(input => {
      if (input._boxSummaryListener) {
        input.removeEventListener('change', input._boxSummaryListener);
      }
      
      const listener = function() {
        updateAllVisibleSummaries();
      };
      
      input._boxSummaryListener = listener;
      input.addEventListener('change', listener);
    });
  }
  
  // Initialize
  function init() {
    if (!window.location.pathname.includes('/cart')) return;
    
    console.log('Initializing box summary updater');
    
    // Set up initial listeners
    setupQuantityListeners();
    
    // Update all summaries initially
    updateAllVisibleSummaries();
    
    // Watch for DOM changes
    const observer = new MutationObserver(mutations => {
      setupQuantityListeners();
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();